export * from './licence-plate-validator';
